import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconBack = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3.75109 12C3.75109 11.8909 3.77437 11.7871 3.81623 11.6936L3.93878 11.5033C3.94912 11.4916 3.95989 11.4801 3.97109 11.4689L11.22 4.22C11.5133 3.92667 11.9889 3.92667 12.2822 4.21999C12.5755 4.51332 12.5755 4.98889 12.2822 5.28222L6.31555 11.2489H19.2489C19.6637 11.2489 20 11.5852 20 12C20 12.4148 19.6637 12.7511 19.2489 12.7511H6.31553L12.2822 18.7178C12.5755 19.0111 12.5755 19.4867 12.2822 19.78C11.9889 20.0733 11.5133 20.0733 11.22 19.78L3.9711 12.5311L3.96949 12.5295C3.90034 12.4599 3.8476 12.3802 3.81129 12.2951C3.77254 12.2045 3.75109 12.1048 3.75109 12Z",
		fill: "currentColor"
	})
});
export { SvgIconBack as ReactComponent };
